<template>
  <div>
    <div>
      <b-breadcrumb :items="itemsBread"></b-breadcrumb>
      <h2 class="ml-2">Profile Page</h2>
      <!-- userType -->
      <div v-if="showForm" class="row p-2 rounded border pt-3 m-2" style="background-color: white;">
        <h4 v-if="showForm" class="mt-2 mb-5">User's Information</h4>
        <div class="col-md-5 border-right h5">
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">User Name </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.user_name != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.user_name }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">User Type </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="user_type != null" class="col-sm-7 mt-2">
                <div>{{ user_type }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">User Id </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.user_id != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.user_id }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">Employee Id</label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.emp_id != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.emp_id }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">User Role </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.user_roles != null" class="col-sm-7 mt-2">
                <div>{{ roleList }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">User Create Date </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.insert_date != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.insert_date }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">Status </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div class="col-sm-7 mt-2">
                <b :class="fetchedData.user_status == 'Y' ? 'text-success' : 'text-danger'">{{
        ((fetchedData.user_status == 'Y') ? 'Active' : 'Inactive')
      }}</b>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-5 h5">
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">User Email </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.user_email != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.user_email }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">Designation </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.designation != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.designation }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">Department Name </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.department_name != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.department_name }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">Password Expiry Date </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.password_expiry_date != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.password_expiry_date }}</div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row">
              <label class="col-sm-4 mt-2">Update Date </label>
              <label class="col-sm-1 mt-2 d-none d-sm-block">: </label>
              <div v-if="fetchedData.update_date != null" class="col-sm-7 mt-2">
                <div>{{ fetchedData?.update_date }}</div>
              </div>
            </div>
          </div>

        </div>

        <div class="col-md-2">
          <div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-2">
              <img :src="avater" :style="{ 'width': '190px', 'height': '185px', 'object-fit': 'cover' }" alt=""
                class="img-thumbnail mx-auto" refs="avater">
            </div>
          </div>
        </div>
        <div v-if="showForm" class="col-md-12 d-flex justify-content-end mb-2">
          <button class="btn btn-info mr-2" @click="updatePage()">Edit Profile</button>
          <RouterLink class="btn btn-dark" to="/users/change-password">Change password</RouterLink>
        </div>
      </div>


    </div>
    <!-- Update Form -->
    <div v-if="!showForm" class="col-md-12 rounded border ml-2 mr-2" style="background-color: white;">
      <h4 class="mt-2 mb-2 p-2">Update Form</h4>
      <div class="row p-2">
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-3">
              <label class="form-label" for="nameControlInput">Name</label>
              <b-form-input id="nameControlInput" v-model="editableUserData.user_name"
                class="form-control userInputField" disabled placeholder="Your Name" type="name" />
            </div>
            <!-- Email -->
            <div class="col-md-3">
              <label class="form-label">User Email</label>
              <input id="userIdControlInput" v-model="editableUserData.user_email"
                :disabled="editableUserData.user_email != ''" class="form-control userInputField"
                placeholder="Your Email" type="email" />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="departmentControlInput">Department Name</label>
              <input id="sControlInput" v-model="editableUserData.department_name" class="form-control userInputField"
                placeholder="Your Department Name" type="department" />
            </div>
            <!-- Designation Name -->
            <div class="col-md-3">
              <label class="form-label" for="designationControlInput">Designation Name</label>
              <input id="sControlInput" v-model="editableUserData.designation" class="form-control userInputField"
                maxlength="11" minlength="11" placeholder="Your Designation Name" type="designation" />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="designationControlInput">Phone Number</label>
              <input id="sControlInput" v-model="editableUserData.phone_no" class="form-control userInputField"
                placeholder="Your Phone Number" type="number" />
              <!--<ul v-if="v$.phone_no.$error" class="parsley-errors-list filled">
                  <li v-for="(value , key) in v$.phone_no.$errors" :key="key"
                      class="parsley-required">{{ value.$message }}
                  </li>
              </ul>-->
            </div>
            <div class="col-md-3">
              <label class="form-label" for="designationControlInput">Address</label>
              <input id="sControlInput" v-model="editableUserData.address" class="form-control userInputField"
                placeholder="Your Address" type="designation" />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="designationControlInput">Web Site</label>
              <input id="sControlInput" v-model="editableUserData.webSite" class="form-control userInputField"
                placeholder="www.webAddress.com" type="designation" />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="designationControlInput">Facebook Url</label>
              <input id="sControlInput" v-model="editableUserData.facebook" class="form-control userInputField"
                placeholder=" https://www.facebook.com/" type="designation" />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="designationControlInput">Twitter Url</label>
              <input id="sControlInput" v-model="editableUserData.twitter" class="form-control userInputField"
                placeholder="https://twitter.com/" type="designation" />
            </div>
            <div class="col-md-3">
              <label class="form-label" for="designationControlInput">LinkedIn Url</label>
              <input id="sControlInput" v-model="editableUserData.linkedIn" class="form-control userInputField"
                placeholder="https://linkedin.com/" type="designation" />
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex flex-column mb-2">
            <img :src="avater" :style="{ 'width': '190px', 'height': '185px', 'object-fit': 'cover' }" alt=""
              class="img-thumbnail  mx-auto" refs="avater">
            <input id="formFileSm" ref="file" accept="image/*" class="form-control form-control-sm mt-4" name="avater"
              type="file" v-on:change="uploadFile">
            <small class="font-size-13 mt-1">Hints: Only jpeg, jpg, png type image is
              allowed</small>
            <!--<ul v-if="v$.imageFileName.$error" class="parsley-errors-list filled">
                    <li v-for="(value , key) in v$.imageFileName.$errors" :key="key"
                        class="parsley-required">{{ value.$message }}
                    </li>
                </ul>-->
          </div>
        </div>
      </div>

      <!-- Name -->

      <div class="col-md-12 d-flex justify-content-end p-3">
        <button class="btn btn-dark mr-2" @click="backToHome()">Back</button>
        <button class="btn btn-primary mr-2" @click="updateProfile()">Update</button>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from '@/services/user.service.js';
import AllUserService from '@/services/all-users.service.js';
import { RouterLink } from 'vue-router';
import { notify } from "@kyvg/vue3-notification";


export default {
  name: "UserProfilePage",
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Profile',
          to: '/users/profile'
        }
      ],
      fetchedData: {},
      editableUserData: {},
      userData: [],
      internalUserInfo: null,
      role: null,
      user_type: null,
      changePassBtn: false,
      showForm: true,
      avater: '',
      upavader: null,
      roleList: [],
    };
  },
  created() {
    this.getUserData();
  },
  methods: {

    uploadFile(e) {
      this.imageFileName = e.target.files[0];
      this.avater = URL.createObjectURL(this.imageFileName);
      this.upavader = e.target.files[0];
    },
    updatePage() {
      this.showForm = false;
    },
    backToHome() {
      this.showForm = true;
    },
    async getUserData() {
      this.fetchedData = await UserService.getUserById();
      const imageData = "data:" + this.fetchedData.profile_image_type + ";base64, " + this.fetchedData.profile_image;
      this.avater = imageData;
      this.upavader = imageData;
      //this.upavader=imageData;
      //console.log("ImageData",this.upavader);
      /*if (this.fetchedData.profile_image != null) {
          console.log("Image data");
          this.handleBase64Image(this.fetchedData.profile_image, this.fetchedData.profile_image_type);
      }*/
      try {
        this.userData = JSON.parse(localStorage.getItem('user'));
        if (this.userData.data.user_type === 1) {
          this.user_type = "Internal";
        } else {
          this.user_type = "External";
        }

      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      this.fetchedData.user_roles.forEach((role, index) => {
        if (index == 0) {
          this.roleList = role.role_name;
        } else {
          this.roleList += ', ' + role.role_name;
        }

      });

      this.editableUserData = { ...this.fetchedData };
    },
    async updateProfile() {
      try {
        const data = {
          'id': this.editableUserData.id,
          'user_id': this.editableUserData.user_id,
          'user_name': this.editableUserData.user_name,
          'user_email': this.editableUserData.user_email,
          'department_name': this.editableUserData.department_name,
          'designation': this.editableUserData.designation,
          'phone_no': this.editableUserData.phone_no,
          'address': this.editableUserData.address,
          'webSite': this.editableUserData.webSite,
          'linkedIn': this.editableUserData.linkedIn,
          'twitter': this.editableUserData.twitter,
          'facebook': this.editableUserData.facebook,
          'profile_image': this.upavader,

        }
        const updateData = await AllUserService.updateProfile(data);
        if (updateData.data.messageCode == 1) {
          notify({
            type: "success",
            title: "Authorization",
            text: updateData.data.message,
          });
          // this.fetchedData = await UserService.getUserById();
          // this.editableUserData = this.fetchedData;
          this.getUserData();
          this.showForm = true;
        } else {
          notify({
            type: "error",
            title: "Authorization",
            text: updateData.data.message,
          });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    convertBase64ToFile(base64String, fileName, mimeType) {
      try {
        const [contentType, base64Data] = base64String.split(';base64,');
        const byteCharacters = btoa(base64Data);
        //const byteCharacters = Buffer.from(base64Data, 'base64').toString();
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: contentType });
        const file = new File([blob], fileName, { type: mimeType });
        return file;
      } catch (error) {
        console.error('Error decoding base64:', error.message);
        // Handle the error as needed
        return null;
      }
    },
    handleBase64Image(base64String, type) {
      const fileName = 'updateUserImage.png';
      const mimeType = type;
      const file = this.convertBase64ToFile(base64String, fileName, mimeType);
      if (file) {
        this.upavader = file;
      } else {
        // Handle the error, e.g., display a message to the user
        console.error('Failed to convert base64 to file.');
      }
    },
  },
  components: { RouterLink }
};

</script>


<style scoped>
.userInputField {
  width: 100%;
  margin-bottom: 10px;
}

p {
  background-color: rgb(222, 243, 236);
  border-radius: 0.5rem;
  padding: 0.5rem;

}

.col-sm-4 {
  font-weight: bold;
  margin-bottom: 16px;
}
</style>
